import { CheckCircleFilled } from "@ant-design/icons";
import { Button, Form, Input, message, Modal } from "antd";
import { useForm } from "antd/es/form/Form";
import Noti from "app/components/Noti";
import Policy from "app/components/Policy";
import Bg from "assets/images/bg-login.png";
import Logo from "assets/images/logo-blue.png";
import { useHandleSubmitApi } from "hook";
import { IResetPasswordInputModel } from "interfaces";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthServices } from "services";
import "../Login/Login.style.scss";
import { PUBLIC_ROUTE } from "constant/routes/page";

type P_Props = {};

const ResetPasswordPresenter = (props: P_Props) => {
  const [form] = useForm();
  const urlParams = new URLSearchParams(window.location.search);

  const [visibleNoti, setVisibleNoti] = useState(false);
  const navigate = useNavigate();

  const [handleSubmitApi, loading] = useHandleSubmitApi(async (data: { password: string; againPassword: string }) => {
    const email = urlParams.get("email");
    const token = urlParams.get("token");

    if (email && token) {
      const cData: IResetPasswordInputModel = {
        email: email,
        token,
        newPassword: data.password,
      };
      const dataRes = await AuthServices.resetPassword(cData);
      if (dataRes) {
        message.success("Đặt lại mật khẩu thành công");
        navigate(PUBLIC_ROUTE.LOGIN);
      }
    } else {
      message.error("Có lỗi xảy ra, vui lòng thử lại!");
    }
  });

  return (
    <>
      <Modal
        open={true}
        width={1680}
        bodyStyle={{ height: "calc(100vh - 190px)" }}
        footer={null}
        closable={false}
        wrapClassName="login-modal"
      >
        <div className="login">
          <Form form={form}>
            <div className="login-form">
              <div className="login-form__inner">
                <img src={Logo} alt="" width={196} />
                <h1>Đặt lại mật khẩu</h1>
                <div className="mb_2 text-center">
                  Bạn vui lòng nhập mật khẩu mới để tiếp tục đăng nhập vào hệ thống
                </div>

                <Form.Item
                  name={"password"}
                  rules={[{ required: true, message: "Vui lòng nhập mật khẩu" }]}
                  style={{ width: "100%" }}
                >
                  <Input size="large" required placeholder="Mật khẩu mới" type="password" />
                </Form.Item>

                <Form.Item
                  name={"againPassword"}
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng nhập lại mật khẩu!",
                    },
                    ({ getFieldValue }) => ({
                      validator(rule, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject("Mật khẩu nhập lại không trùng khớp!");
                      },
                    }),
                  ]}
                  style={{ width: "100%" }}
                >
                  <Input size="large" required placeholder="Nhập lại mật khẩu" type="password" />
                </Form.Item>

                <Button
                  size="large"
                  className="btn btn-full mt_2"
                  onClick={() => form.validateFields().then(handleSubmitApi)}
                  loading={loading}
                >
                  Lưu mật khẩu
                </Button>
                <div className="login-form__footer">
                  <Policy />
                </div>
              </div>
            </div>
          </Form>
          <div className="login-image">
            <img src={Bg} alt="" height={"100%"} width={"100%"} />
          </div>
        </div>
      </Modal>

      {visibleNoti && (
        <Noti
          visible={visibleNoti}
          icon={{ color: "browse", children: <CheckCircleFilled style={{ color: "#D38123", fontSize: 64 }} /> }}
          title={"Mật khẩu mới đã được cập nhật"}
          subTitle={"Chúc mừng! Mật khẩu mới đã được cập nhật. Vui lòng đăng nhập để tiếp tục truy cập vào hệ thống."}
          actions={
            <>
              <Button
                size="large"
                className="btn btn-outline"
                style={{ width: 240 }}
                onClick={() => {
                  setVisibleNoti(false);
                  navigate(PUBLIC_ROUTE.LOGIN);
                }}
              >
                Đăng nhập ngay
              </Button>
            </>
          }
        />
      )}
    </>
  );
};

export default ResetPasswordPresenter;
